module.exports = __webpack_public_path__ + "static/media/logo-nav.85fbe297.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/logo-nav.png
// module id = 649
// module chunks = 0